import { createReducer, on } from "@ngrx/store";
import { SettingActions } from "./setting.actions";
import { ModalConfirmProps } from "../../shared/models/modal-confirm";
import { AlertProps } from "../../shared/models/alert-props";

export interface SettingState {
    isLoading: boolean;
    modalConfirm: ModalConfirmProps | null;
    alert: AlertProps | null;
}

export const initialStateSetting: SettingState = {
    isLoading: false,
    modalConfirm: null,
    alert: null,
}

export const settingReduce = createReducer(
    initialStateSetting,

    on(SettingActions.openSpinner, (state) => {
        return {
            ...state,
            isLoading: true
        };
    }),
    on(SettingActions.closeSpinner, (state) => {
        return {
            ...state,
            isLoading: false
        };
    }),
    on(SettingActions.openModal, (state, element) => {
        return {
            ...state,
            modalConfirm: {
                description: element.description,
                open: element.open,
                title: element.title,
                confirm: element.confirm,
                btnCloseLabel: element.btnCloseLabel,
                btnConfirmLabel: element.btnConfirmLabel,
                isBtnConfirmDisabled: element.isBtnConfirmDisabled
            },
        };
    }),
    on(SettingActions.closeModal, (state) => ({ ...state, modalConfirm: initialStateSetting.modalConfirm })),
    on(SettingActions.openAlert, (state, element) => {
        return {
            ...state,
            alert: {
                message: element.message,
                variant: element.variant,
                duration: element.duration,
                open: true
            },
        };
    }),
    on(SettingActions.closeAlert, (state) => ({ ...state, alert: initialStateSetting.alert })),
)
